import React, { useState, useEffect } from "react";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  IconLookup,
  IconDefinition,
  findIconDefinition,
} from "@fortawesome/fontawesome-svg-core";
import countriesDropdownValues from "../Utils/CountriesUN";
import DropDMultiple from "./InputComponents/DropDMultiple";
import CardHeader from "./Utils/CardHeaderComponent";
import DropdownNumberMandatory from "./InputComponents/DropdownNumberMandatoryComponent";
import TextConfidential from "./InputComponents/TextConfidentialComponent";
import DropdownStringMandatory from "./InputComponents/DropdownStringMandatoryComponent";
import DropDTextMultiple from "./InputComponents/DropDTextMultipleComponent";
import ConfirmationModal from "./Utils/ConfirmationModal";

library.add(faTrashCan);
const trashLookup: IconLookup = { prefix: "fas", iconName: "trash-can" };
const trashcanDefinition: IconDefinition = findIconDefinition(trashLookup);
library.add(faAngleRight);
const angleLookup: IconLookup = { prefix: "fas", iconName: "angle-right" };
const angleDefinition: IconDefinition = findIconDefinition(angleLookup);
interface SMEsProps {
  errors: string[];
  dropdownValues: {
    tab: string;
    inputName: string;
    listValue: string[];
  }[];
  picNumbers: string[];
  data: {
    // ### SET 4.0 ###

    areSMEsInvolvedAsBeneficiaries: string;
    picNumber: string;
    category: string[];
    otherTextBox: string;
    otherTextSensitive: boolean;

    // ### SET 4.1 ###

    b2bMultiple: string[];
    b2bMultipleText: string;
    b2bMultipleSensitive: boolean;
    // ### SET 4.2 ###

    b2cMultiple: string[];
    b2cMultipleText: string;
    b2cMultipleSensitive: boolean;
  };

  handleOnChangeSMEs: (
    e?: React.ChangeEvent<any>,
    dropDown?: {
      name: string;
      value: string[];
    }
  ) => void;
  handleDeleteSMEs: () => void;
}

function SMEs({
  errors,
  data,
  handleOnChangeSMEs,
  handleDeleteSMEs,
  picNumbers,
  dropdownValues,
}: SMEsProps) {
  const [isHidden, setIsHidden] = useState(true);
  const toggleVisibility = () => {
    setIsHidden((prevState) => !prevState);
  };
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleDeleteClick = () => {
    setIsModalOpen(true);
  };
  const confirmDelete = () => {
    setIsModalOpen(false);
    handleDeleteSMEs();
  };
  const cancelDelete = () => {
    setIsModalOpen(false);
  };
  console.log(data.category.length);
  return (
    <div className="feedstock-container">
      <CardHeader
        isHidden={isHidden}
        toggleVisibility={toggleVisibility}
        cardName="SME"
        handleDelete={handleDeleteClick}
        notValid={errors.length > 0}
      />
      <div className={isHidden ? "hidden-content" : "visible-content"}>
        <div className="form-container">
          <div className="error-container">
            {errors.map((error, index) => (
              <div
                className="error-text"
                key={index}
                style={{ marginBottom: "10px" }}
              >
                {error}
              </div>
            ))}
          </div>
          <div className="questions-wrapper">
          {/* ############ SET 4.0 ############ */}
          <div className="row">
            <div className="col-md-12">
              <DropdownStringMandatory
                listInputs={["-", "Yes", "No"]}
                label={"Are SMEs involved in the project as beneficiaries?"}
                inputName={"areSMEsInvolvedAsBeneficiaries"}
                value={data.areSMEsInvolvedAsBeneficiaries}
                handleOnChange={handleOnChangeSMEs}
                invalidValues={["", "-"]}
              />
            </div>
          </div>
          <div
            className={
              data.areSMEsInvolvedAsBeneficiaries == "Yes"
                ? "visible-content"
                : "hidden-content"
            }
          >
            <div className="row">
              <div className="col-md-12">
                <DropdownStringMandatory
                  listInputs={picNumbers}
                  label={"Please select the SME"}
                  inputName={"picNumber"}
                  value={data.picNumber}
                  handleOnChange={handleOnChangeSMEs}
                  invalidValues={["", "-"]}
                />
              </div>
              <div className="col-md-12">
                <div
                  className={
                    data.picNumber == "" || data.picNumber == "-"
                      ? "hidden-content"
                      : "visible-content"
                  }
                >
                  <DropDTextMultiple
                    listInputs={
                      dropdownValues.filter(
                        (item) => item.inputName == "category"
                      )[0].listValue
                    }
                    label={"Please select role of the SME in the project"}
                    inputName={"category"}
                    value={data.category}
                    handleOnChange={handleOnChangeSMEs}
                    isValid={data.category.length > 0}
                  />
                </div>
                {data.category.includes("Other") ? (
                  <>
                    <TextConfidential
                      label={"Please explain"}
                      textValid={data.otherTextBox.length > 4}
                      textValue={data.otherTextBox}
                      textName={"otherTextBox"}
                      onChange={handleOnChangeSMEs}
                      isConfidential={data.otherTextSensitive}
                      confidentialInputName={"otherTextSensitive"}
                      display={false}
                    />
                  </>
                ) : null}
                <div
                  className={
                    data.category.includes("Business to business (B2B)")
                      ? "visible-content"
                      : "hidden-content"
                  }
                >
                  <div className="question-group-input-first">
                    <div className="col-sm-12">
                      <DropDTextMultiple
                        listInputs={
                          dropdownValues.filter(
                            (item) => item.inputName == "b2bMultiple"
                          )[0].listValue
                        }
                        label={
                          "Please indicate in which B2B sectors your SME is involved"
                        }
                        inputName={"b2bMultiple"}
                        value={data.b2bMultiple}
                        handleOnChange={handleOnChangeSMEs}
                        isValid={data.b2bMultiple.length > 0}
                      />
                    </div>
                    <div className="col-md-12">
                      <div
                        className={
                          data.b2bMultiple.includes("Others")
                            ? "visible-content"
                            : "hidden-content"
                        }
                      >
                        <TextConfidential
                          label={"Please describe"}
                          textValid={data.b2bMultipleText.length > 4}
                          textValue={data.b2bMultipleText}
                          textName={"b2bMultipleText"}
                          onChange={handleOnChangeSMEs}
                          isConfidential={data.b2bMultipleSensitive}
                          confidentialInputName={"b2bMultipleSensitive"}
                          display={false}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={
                    data.category.includes("Business to consumers (B2C)")
                      ? "visible-content"
                      : "hidden-content"
                  }
                >
                  <div className="question-group-input-first">
                    <div className="col-sm-12">
                      <DropDTextMultiple
                        listInputs={
                          dropdownValues.filter(
                            (item) => item.inputName == "b2cMultiple"
                          )[0].listValue
                        }
                        label={
                          "Please indicate in which B2C sectors your SME is involved"
                        }
                        inputName={"b2cMultiple"}
                        value={data.b2cMultiple}
                        handleOnChange={handleOnChangeSMEs}
                        isValid={data.b2cMultiple.length > 0}
                      />
                    </div>
                    <div className="col-md-12">
                      <div
                        className={
                          data.b2cMultiple.includes("Others")
                            ? "visible-content"
                            : "hidden-content"
                        }
                      >
                        <TextConfidential
                          label={"Please describe"}
                          textValid={data.b2cMultipleText.length > 4}
                          textValue={data.b2cMultipleText}
                          textName={"b2cMultipleText"}
                          onChange={handleOnChangeSMEs}
                          isConfidential={data.b2cMultipleSensitive}
                          confidentialInputName={"b2cMultipleSensitive"}
                          display={false}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
      <ConfirmationModal
        isOpen={isModalOpen}
        onRequestClose={cancelDelete}
        onConfirm={confirmDelete}
        title="
        Confirm deletion"
        message="Are you sure you want to delete this component ?"
      />
    </div>
  );
}

const b2bcategories = [
  "Platform chemicals",
  "Polymers",
  "Composites",
  "Additives",
  "Solvents",
  "Surfactants",
  "Fibres",
  "Feed ingredients and nutrients",
  "Food ingredients and nutrients",
  "Agrochemicals for crop protection",
  "Agrochemicals for fertilisers",
  "Paints, inks, dyes",
  "Coatings",
  "Adhesives / Binders",
  "Chemicals & Materials design and simulation",
  "Biofuel",
  "Biogas",
  "Others",
];
const b2ccategories = [
  "Platform chemicals",
  "Agriculture",
  "Construction & Building Materials",
  "Food",
  "Feed",
  "Home care",
  "Automotive",
  "Packaging",
  "Personal care and cosmetics",
  "Textile",
  "Energy",
  "Emerging markets for the biobased products (e.g. Electronics)",
  "Others",
];
export default SMEs;
